import { render, staticRenderFns } from "./agreementDetail.vue?vue&type=template&id=2203269c&scoped=true"
import script from "./agreementDetail.vue?vue&type=script&lang=js"
export * from "./agreementDetail.vue?vue&type=script&lang=js"
import style0 from "./agreementDetail.vue?vue&type=style&index=0&id=2203269c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203269c",
  null
  
)

export default component.exports